export const DEFAULT_DATE_FNS_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_FNS_DATE_TIME_FORMAT = 'yyyy-MM-DD HH:mm:ss';
export const DATE_PICKER_INPUT_MASK_FORMAT = 'yyyy/MM/dd';
export const DATE_PICKER_INPUT_FORMAT = 'MMM dd, yyyy';
export const VIDEO_UPLOAD_LIMIT = 10737418240;
export const DEFAULT_UPLOAD_LIMIT = 10485760;
